export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    showTable({commit}) {
        commit('showTable');
    },

    showForm({commit}) {
        commit('showForm');
    },
    modifyEllatasVegeVisible({commit}, visible) {
        commit('modifyEllatasVegeVisible', visible);
    },
    modifyAmbulansEllatasTipus({commit}, visible) {
        commit('modifyAmbulansEllatasTipus', visible);
    }
}
